export default "__VITE_ASSET__CDPyd39k__"